import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { generateConfirmationLetterPdf } from './generateConfirmationLetterPdf';
import { loadBrandLogoDataUrl, loadSavedCrestDataUrl } from './letterAssets';

// Builds the Your Tour / MST confirmation letter and queues it for send via the
// existing quoteLetterRequests → onQuoteLetterRequested email pipeline.
// There's no interactive upload moment at any of this function's call sites
// (deposit-paid, or a plain resend), so the crest always comes from whatever
// was already saved to the tour rather than an ephemeral upload.
// `reason: 'meals_updated'` marks the staff re-send once flight times are
// known, so the covering email says the letter was updated; anything else is
// worded as the first confirmation letter (the deposit-paid send).
export async function sendConfirmationLetterEmail(request, reason = null) {
  const confirmationPdfBase64 = await buildConfirmationLetterPdf(request);
  await addDoc(collection(db, 'quoteLetterRequests'), {
    requestId: request.id,
    confirmationLetterPdfBase64: confirmationPdfBase64,
    ...(reason ? { reason } : {}),
    requestedAt: serverTimestamp(),
  });
}

// Builds the same PDF without sending it — shared by the send above and the
// staff "Preview confirmation letter" button.
export async function buildConfirmationLetterPdf(request) {
  const logoDataUrl = await loadBrandLogoDataUrl(request.brand);
  const savedCrestDataUrl = await loadSavedCrestDataUrl(request.crestUrl);
  return generateConfirmationLetterPdf(request, logoDataUrl, savedCrestDataUrl);
}
